import { Link } from "react-router-dom";
import { Compass } from "@phosphor-icons/react";

export function Footer() {
  return (
    <footer className="bg-[#1A1C19] text-[#FAFAF7] mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Compass size={26} weight="duotone" className="text-[#E8B291]" />
            <span className="font-display text-2xl font-bold">TravelNext</span>
          </div>
          <p className="text-[#A8ABA2] max-w-sm leading-relaxed">
            Discover, plan and gear up for your next journey. AI-crafted itineraries,
            shareable trip boards and a curated travel shop — all in one place.
          </p>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#E8B291] mb-4 font-sans">Explore</h4>
          <ul className="space-y-3 text-[#C9CCC4]">
            <li><Link to="/explore" className="hover:text-white transition-colors duration-200">Destinations</Link></li>
            <li><Link to="/chat" className="hover:text-white transition-colors duration-200">AI Concierge</Link></li>
            <li><Link to="/boards" className="hover:text-white transition-colors duration-200">Trip Boards</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs tracking-[0.2em] uppercase font-bold text-[#E8B291] mb-4 font-sans">Shop</h4>
          <ul className="space-y-3 text-[#C9CCC4]">
            <li><Link to="/shop" className="hover:text-white transition-colors duration-200">Bags</Link></li>
            <li><Link to="/shop" className="hover:text-white transition-colors duration-200">Apparel</Link></li>
            <li><Link to="/shop" className="hover:text-white transition-colors duration-200">Gear</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-sm text-[#8B8E85]">
          © {new Date().getFullYear()} TravelNext. Crafted for wanderers.
        </div>
      </div>
    </footer>
  );
}
